'use client';

import './menuTabNavigation.css';
import 'react-tabs-scrollable/dist/rts.css';

import { BaseSyntheticEvent, useContext, useState } from 'react';
import { Tab, TabScreen, Tabs } from 'react-tabs-scrollable';

import { ArrowBlack } from '@/components/common/Icons/ArrowBlack';
import { CartContext } from '../../CartProvider/CartProvider';
import { FEATURE_FLAGS } from '@/lib/featureFlags';
import { LeftArrow } from '@/components/common/Icons/LeftArrow';
import { Loading } from '@/components/common/Icons/Loading';
import { MenuNavigationPanelContents } from './MenuNavigationPanelContents';
import { RightArrow } from '@/components/common/Icons/RightArrow';
import { sendGAEvent } from '@next/third-parties/google';
import { smoothScrollToTop } from '@/utils/smoothScrollToTop';
import { useFlags } from 'launchdarkly-react-client-sdk';

export function CategoryWiseTabNavigation() {
	const { storeMenuData } = useContext(CartContext);
	const [activeTab, setActiveTab] = useState(0);
	const { [FEATURE_FLAGS.singleColumnPlpFlag]: isSingleColumnPlpFlagEnabled } = useFlags();

	const onTabClick = (event: BaseSyntheticEvent<object>, index: number) => {
		smoothScrollToTop();
		const categoryName = event.target.textContent;
		setActiveTab(index);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'menu_category_selection',
			eventModel: {
				menu_category: categoryName,
			},
		});
	};

	const onNavBtnClick = (navBtn: 'left' | 'right') => {
		sendGAEvent(
			'event',
			navBtn === 'left' ? 'menu_category_nav_left' : 'menu_category_nav_right',
			{}
		);
	};

	const scrollToCategory = (direction: string) => {
		if (direction === 'left') {
			setActiveTab(activeTab - 1);
		} else {
			setActiveTab(activeTab + 1);
		}
		smoothScrollToTop();
	};

	// Get Adjacent Category to display on Footer
	const getAdjacentCategories = () => {
		const leftCategory =
			activeTab > 0 ? storeMenuData?.storeMenu?.categories[activeTab - 1].name : null; // Left category
		const rightCategory =
			storeMenuData?.storeMenu?.categories &&
			activeTab < storeMenuData?.storeMenu?.categories.length - 1
				? storeMenuData?.storeMenu?.categories[activeTab + 1].name
				: null; // Right category
		return { leftCategory, rightCategory };
	};

	const { leftCategory, rightCategory } = getAdjacentCategories();

	return (
		<>
			{!storeMenuData ? (
				<div className="flex justify-center">
					<Loading size="large" fill="green" />
				</div>
			) : (
				<>
					<div className="tab-container container me-auto ms-auto flex items-center justify-start">
						<Tabs
							mode="scrollSelectedToCenterFromView"
							activeTab={activeTab}
							onTabClick={onTabClick}
							rightBtnIcon={
								<ArrowBlack
									className="icon ml-auto self-center stroke-none"
									style={{
										background: 'linear-gradient(90deg, transparent, 10%, #fff)',
										width: '40px',
										height: '15px',
									}}
									onClick={() => onNavBtnClick('right')}
								/>
							}
							leftBtnIcon={
								<ArrowBlack
									className="icon ml-auto rotate-180 self-center stroke-none"
									style={{
										background: 'linear-gradient(90deg, transparent, 10%, #fff)',
										width: '40px',
										height: '15px',
									}}
									onClick={() => onNavBtnClick('left')}
								/>
							}
							hideNavBtns={false}
							hideNavBtnsOnMobile={false}
							leftNavBtnClassName="left-0"
							rightNavBtnClassName="right-0"
							navBtnStyle={{
								'--rts-primary-color': '#fff',
								borderStyle: 'none',
								height: '20px',
								position: 'absolute',
								top: '9px',
								zIndex: '200',
							}}
						>
							{storeMenuData?.storeMenu?.categories.map((category, index: number) => (
								<Tab key={index} className="tab-list menu_category_tab_cta font-bold">
									{category.name}
								</Tab>
							))}
						</Tabs>
					</div>
					<div className="container me-auto ms-auto items-center justify-start gap-8">
						{storeMenuData?.storeMenu?.categories?.map((category, index: number) => (
							<TabScreen key={index} activeTab={activeTab} index={index}>
								<MenuNavigationPanelContents
									category={category}
									categoryIndex={index}
									isSingleColumnPlpFlagEnabled={isSingleColumnPlpFlagEnabled}
								/>
							</TabScreen>
						))}
					</div>
					<div className="container mb-6 me-auto ms-auto items-center justify-start gap-8 px-2 md:px-0">
						<div className="flex justify-between">
							{leftCategory && (
								<button
									className="flex w-full flex-row items-center justify-start"
									onClick={() => scrollToCategory('left')}
								>
									<LeftArrow />
									<p className="text-base font-black" data-type-style="title-4" data-ink="medium">
										{leftCategory}
									</p>
								</button>
							)}

							{rightCategory && (
								<button
									className="flex w-full flex-row items-center justify-end"
									onClick={() => scrollToCategory('right')}
								>
									<p className="text-base font-black" data-type-style="title-4" data-ink="medium">
										{rightCategory}
									</p>
									<RightArrow />
								</button>
							)}
						</div>
					</div>
				</>
			)}
		</>
	);
}
